module.exports = __webpack_public_path__ + "static/media/video-placeholder.811ff17d.png";